var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 8,
    viewBox: "0 0 6 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.87337 2.81683C5.52337 1.27683 4.18003 0.583496 3.00003 0.583496C3.00003 0.583496 3.00003 0.583496 2.9967 0.583496C1.82003 0.583496 0.473365 1.2735 0.123365 2.8135C-0.266635 4.5335 0.786699 5.99016 1.74003 6.90683C2.09337 7.24683 2.5467 7.41683 3.00003 7.41683C3.45337 7.41683 3.9067 7.24683 4.2567 6.90683C5.21003 5.99016 6.26337 4.53683 5.87337 2.81683ZM3.00003 4.48683C2.42003 4.48683 1.95003 4.01683 1.95003 3.43683C1.95003 2.85683 2.42003 2.38683 3.00003 2.38683C3.58003 2.38683 4.05003 2.85683 4.05003 3.43683C4.05003 4.01683 3.58003 4.48683 3.00003 4.48683Z",
    fill: "#BD553D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation2);
export default __webpack_public_path__ + "static/media/location2.4c6e6ef30a24cf5695313c0210b20805.svg";
export { ForwardRef as ReactComponent };